import axios from '@/app/plugins/Axios'

export default new class VendedoresService {

  listar() {
    return axios.get('vendedores')
      .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/vendedores/' + id)
      .then(response => response.data);
  }

  salvar(vendedor) {
    return axios.post('/vendedores', vendedor)
      .then(response => response.data);
  }

  atualizar(vendedor) {
    return axios.put('/vendedores/'+ vendedor.id, vendedor)
      .then(response => response.data)
      .catch(error => {
        throw error.response;
      });
  }

  excluir(id) {
    return axios.delete('/vendedores/' + id)
      .then(response => response.data);
  }
}
